var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9286 4.28571C19.2262 4.28571 19.4792 4.38988 19.6875 4.59821C19.8958 4.80655 20 5.05952 20 5.35714V18.9286C20 19.2262 19.8958 19.4792 19.6875 19.6875C19.4792 19.8958 19.2262 20 18.9286 20H8.21429C7.91667 20 7.66369 19.8958 7.45536 19.6875C7.24702 19.4792 7.14286 19.2262 7.14286 18.9286V15.7143H1.07143C0.77381 15.7143 0.520833 15.6101 0.3125 15.4018C0.104167 15.1935 0 14.9405 0 14.6429V7.14286C0 6.84524 0.0744048 6.51786 0.223214 6.16071C0.372024 5.80357 0.550595 5.52083 0.758929 5.3125L5.3125 0.758929C5.52083 0.550595 5.80357 0.372024 6.16071 0.223214C6.51786 0.0744048 6.84524 0 7.14286 0H11.7857C12.0833 0 12.3363 0.104167 12.5446 0.3125C12.753 0.520833 12.8571 0.77381 12.8571 1.07143V4.73214C13.3631 4.43452 13.8393 4.28571 14.2857 4.28571H18.9286ZM12.8571 6.66295L9.52009 10H12.8571V6.66295ZM5.71429 2.37723L2.37723 5.71429H5.71429V2.37723ZM7.90179 9.59821L11.4286 6.07143V1.42857H7.14286V6.07143C7.14286 6.36905 7.03869 6.62202 6.83036 6.83036C6.62202 7.03869 6.36905 7.14286 6.07143 7.14286H1.42857V14.2857H7.14286V11.4286C7.14286 11.131 7.21726 10.8036 7.36607 10.4464C7.51488 10.0893 7.69345 9.80655 7.90179 9.59821ZM18.5714 18.5714V5.71429H14.2857V10.3571C14.2857 10.6548 14.1815 10.9077 13.9732 11.1161C13.7649 11.3244 13.5119 11.4286 13.2143 11.4286H8.57143V18.5714H18.5714Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.bcabe018561b9f3e83a45c5ae1302c2b.svg";
export { ForwardRef as ReactComponent };